module.exports = __webpack_public_path__ + "static/news2-575bd08ba9db2c50c68f61ea10858dc5.png";